import React, { Component } from 'react';
import { Button } from '@blueprintjs/core';
import InputPassword from './InputPassword'
import Input from './Input'

class LoginForm extends Component {
	render() {
		return <div className = "loginWrapper">
			<div className = "uk-vertical-align uk-text-center uk-height-1-1">
				<div className="loginForm">
					<img style = {{width: 'auto'}} src = {require('../../img/automat.png')} alt = 'Logo'>
					</img>
					<h2>{ this.props.changePass ? 'Please Login & Change Password' : 'Please Login' } </h2>
					<form>
						<Input
							placeholder = 'username'
							attr = 'username'
							onChange = {this.props.setInput}
							onKeyUp = {this.props.submitOnEnter}
							value = {this.props.username}
						/>
						<InputPassword 
							placeholder = 'password'
							attr = 'password'
							onChange = {this.props.setInput}
							onKeyUp = {this.props.submitOnEnter}
							value = {this.props.password}
						/>
						{ this.changePass() }
						<br/>
						<Button className="pt-fill pt-large pt-intent-primary" 
							onClick={this.props.loginSubmit}>
								{ this.props.changePass ? 'Change Password & Login' : 'Login' } 
						</Button>
					</form>
				</div>
			</div>
		</div>
	}

	changePass = () => {
		if(this.props.changePass === true) {
			return [
				<InputPassword 
					placeholder = 'new password'
					attr = 'password1'
					onChange = {this.props.setInput}
					onKeyUp = {this.props.submitOnEnter}
					value = {this.props.password1}
					key = {1}
				/>,
				<InputPassword 
					placeholder = 'retype new password'
					attr = 'password2'
					onChange = {this.props.setInput}
					onKeyUp = {this.props.submitOnEnter}
					value = {this.props.password2}
					key = {2}
				/>
			];
		}
		return null;
	}
}

export default LoginForm;



// WEBPACK FOOTER //
// ./src/components/login/LoginForm.js